import { Controller } from 'stimulus';

export default class extends Controller {
  static outlets = ['quiz-sidebar'];

  onFieldChange(event) {
    if (!this.hasQuizSidebarOutlet) {
      return;
    }

    const fieldset = event.target.closest('[data-part-id]');
    if (!fieldset) {
      return;
    }

    const partId = fieldset.dataset.partId;
    const answered = this._isPartAnswered(fieldset);

    if (answered) {
      this.quizSidebarOutlet.markAnswered(partId);
    } else {
      this.quizSidebarOutlet.markUnanswered(partId);
    }
  }

  _isPartAnswered(fieldset) {
    const radios = Array.from(fieldset.querySelectorAll('input[type=radio]'));
    if (radios.length && this._isMandatory(fieldset)) {
      return this._allRadioGroupsChecked(radios);
    }

    const choices = fieldset
      .querySelectorAll('input[type=radio], input[type=checkbox]');

    if (choices.length) {
      return Array.from(choices).some((el) => el.checked);
    }

    const texts = fieldset.querySelectorAll('input[type=text], textarea');

    return Array.from(texts)
      .some((el) => el.value.trim() !== '');
  }

  _isMandatory(fieldset) {
    return fieldset.dataset.questionnaireMandatoryTarget === 'mandatoryGroup';
  }

  _allRadioGroupsChecked(radios) {
    const byName = new Map();

    radios.forEach((radio) => {
      if (!byName.has(radio.name)) byName.set(radio.name, []);
      byName.get(radio.name).push(radio);
    });

    return Array.from(byName.values()).every((named) => named.some((el) => el.checked));
  }
}
